Hideaways.pointsExpiry = function () {
    var notice = new PointsExpiry();
    notice.init();

    Hideaways._pointsExpiry = notice;
}
